<template>

  <div class="self-center flex-1 text-gray-800 text-center px-4 py-2 m-2 text-brand-green container max-w-md mx-auto text-center">
    <h2 class="mb-10 text-3xl font-heading">Thanks for signing up </h2>
    <h2 class="mb-10 font-bold">You are almost ready to go, we just need your card information.</h2>
    <div class="mb-4">Your card will be charged at the end of the 7 day trial. You can cancel at any point before then and you won’t be charged. We will remind you 1 day before your trial is up.</div>
    <card
      class="stripe-card my-6"
      :class="{ complete }"
      stripe="pk_test_ZYclzxvLy3gH5nYLXyZdikyb00aouyZhag"
      :options="stripeOptions"
      @change="complete = $event.complete"
    />

    <button class="pay-with-stripe bg-brand-green text-white w-full rounded p-2 mb-3" @click="createSubscription" :disabled="!complete">Subscribe</button>
  </div>
</template>

<script>
import { Card } from 'vue-stripe-elements-plus'

export default {
  name: 'Home',
  components: {
    Card
  },
  methods: {
    async createSubscription () {
      this.$store.dispatch('createSubscription')
    }
  },
  data () {
    return {
      complete: false,
      stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      }
    }
  }
}

</script>

<style scoped lang="scss">
.githublogo{
  width: 41px;
  height: 40px;

}
</style>
